import React from 'react'
import { Outlet } from 'react-router-dom'

const AnalyticsLayout: React.FC = () => {
  return <Outlet />
}

export default AnalyticsLayout
